import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { CustomMessageModel } from 'src/app/models/api.model'
import { WebService } from '../api/web.service'
import { ServiceUrlConstants } from 'src/app/constants/service-url-constants'

@Injectable({
  providedIn: 'root'
})
export class CustomMessageService {
  constructor(private webService: WebService) {}

  getCustomMessage(messageKey: string): Observable<CustomMessageModel> {
    return this.webService.get(`${ServiceUrlConstants.API_CUSTOM_MESSAGE}${messageKey}`)
  }
}
